export default "__VITE_ASSET__okYAV$Ku__"